import { render, staticRenderFns } from "./TheRingSeperator.vue?vue&type=template&id=4fecaf0e"
import script from "./TheRingSeperator.vue?vue&type=script&lang=js"
export * from "./TheRingSeperator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports